import { generatePath, Route, Redirect, Router, Switch, withRouter } from 'react-router-dom';
import PortalIdParser from 'PortalIdParser';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Only import and use "containers" for your route handlers
import ApplicationContainer from './containers/ApplicationContainer';
import InboxContainerWithOnboarding from './components/InboxContainerWithOnboarding';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { CONTACT } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ContactReferenceResolver from 'reference-resolvers/resolvers/ContactReferenceResolver';
import ResponderReferenceResolver from './reference-resolvers/resolvers/ResponderReferenceResolver';
import VisitorReferenceResolver from './reference-resolvers/resolvers/VisitorReferenceResolver';
import { RESPONDER, VISITOR } from './reference-resolvers/constants/ResolverKeys';
import RedirectIfMissingAppScope from './routing/components/RedirectIfMissingAppScope';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HUBSPOT_DASHBOARD = '/reports-dashboard';
const APP_BASE_PATH = '/live-messages';
const INBOX_PATH = '/live-messages/:portalId/inbox/:threadId?';
const ANY_INBOX_PATH = '/live-messages*';

// ensures that ApplicationContainer re-renders when
// location changes.
const ApplicationContainerWithRouter = withRouter(ApplicationContainer);
const InboxRoutes = ({
  history
}) => {
  const getInboxPath = () => {
    return generatePath(INBOX_PATH, {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
      portalId: PortalIdParser.get()
    });
  };
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'PartialR... Remove this comment to see the full error message
    _jsx(RhumbProvider, {
      history: historyAdapter(history),
      config: rhumbConfig,
      children: /*#__PURE__*/_jsx(Router, {
        history: history,
        children: /*#__PURE__*/_jsx(Route, {
          path: APP_BASE_PATH,
          children: /*#__PURE__*/_jsxs(ApplicationContainerWithRouter, {
            children: [/*#__PURE__*/_jsxs(Switch, {
              children: [/*#__PURE__*/_jsx(Route, {
                path: INBOX_PATH,
                component: InboxContainerWithOnboarding
              }), /*#__PURE__*/_jsx(Redirect, {
                from: ANY_INBOX_PATH,
                to: getInboxPath()
              })]
            }), /*#__PURE__*/_jsx(RedirectIfMissingAppScope, {
              external: true,
              from: ANY_INBOX_PATH,
              to: HUBSPOT_DASHBOARD
            })]
          })
        })
      })
    })
  );
};
InboxRoutes.displayName = 'InboxRoutes';
export default ProvideReferenceResolvers({
  [CONTACT]: ContactReferenceResolver,
  [RESPONDER]: ResponderReferenceResolver,
  [VISITOR]: VisitorReferenceResolver
}, InboxRoutes);